(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-delivery-checker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.classList || !form.classList.contains('pdp-edd__form')) return;
    event.preventDefault();

    var root = form.parentElement;
    var input = form.querySelector('.pdp-edd__input');
    var result = root.querySelector('.pdp-edd__result');
    var panel = root.querySelector('.pdp-edd__panel');
    if (!input || !result || !panel) return;

    var value = (input.value || '').trim();
    var valid = /^[1-9][0-9]{5}$/.test(value);
    var error = form.getAttribute('data-error') || 'Please enter a valid 6-digit pincode.';

    if (!valid) {
      panel.hidden = true;
      form.hidden = false;
      result.hidden = false;
      result.classList.add('is-error');
      result.textContent = error;
      return;
    }

    var daysMatch = (form.getAttribute('data-success') || '').match(/(\d+)/);
    var days = daysMatch ? parseInt(daysMatch[1], 10) : 7;
    var date = new Date();
    date.setDate(date.getDate() + days);
    var weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var formatted = weekdays[date.getDay()] + ', ' + date.getDate() + ' ' + months[date.getMonth()];

    result.hidden = true;
    form.hidden = true;
    var label = root.querySelector('.pdp-edd__label');
    if (label) label.hidden = true;
    panel.hidden = false;
    panel.querySelector('.pdp-edd__code').textContent = value;
    panel.querySelector('.pdp-edd__date').textContent = formatted;
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.pdp-edd__change');
    if (!button) return;
    var root = button.closest('.pdp-edd');
    if (!root) return;
    var form = root.querySelector('.pdp-edd__form');
    var panel = root.querySelector('.pdp-edd__panel');
    var label = root.querySelector('.pdp-edd__label');
    if (panel) panel.hidden = true;
    if (label) label.hidden = false;
    if (form) {
      form.hidden = false;
      var input = form.querySelector('.pdp-edd__input');
      if (input) input.focus();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
